import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import getDriver from '../../routes/site-admin/editDriver/getDriver.graphql';
import getDriverOngoingBookings from '../../routes/site-admin/editDriver/getDriverOngoingBookings.graphql';

export function adminResetDriverStatus(driverId, profileId) {
  return async (dispatch, getState, { client }) => {
    dispatch(setLoaderStart('ResetDriverStatus'));

    const mutation = gql`
        mutation adminResetDriverStatus($driverId: ID) {
            adminResetDriverStatus(driverId: $driverId) {
                status
                errorMessage
            }
        }
    `;

    try {
      const { data } = await client.mutate({
        mutation,
        variables: {
          driverId
        },
        refetchQueries: [
          {
            query: getDriver,
            variables: {
              id: Number(profileId)
            }
          },
          {
            query: getDriverOngoingBookings,
            variables: {
              id: String(driverId)
            }
          }
        ]
      });

      if (data && data.adminResetDriverStatus && data.adminResetDriverStatus.status === 200) {
        toastr.success('Success!', 'Driver status has been reset and active status set to active!');
        return true;
      } else {
        const errorMessage = (data && data.adminResetDriverStatus && data.adminResetDriverStatus.errorMessage)
          ? data.adminResetDriverStatus.errorMessage
          : 'Failed to reset driver status';
        toastr.error("Error!", errorMessage);
        return false;
      }
    } catch (error) {
      toastr.error("Error!", error.message);
      return false;
    } finally {
      dispatch(setLoaderComplete('ResetDriverStatus'));
    }
  }
}
